module.exports = __webpack_public_path__ + "static/media/Produtos2.8a6b12ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadProdutos/Produtos2.png
// module id = 2001
// module chunks = 0